import React from 'react';
import Layout from '../components/Layout';
import Landing from '../sections/Landing';
import About from '../sections/About';
import Projects from '../sections/Projects';
import Map from '../components/Map';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Recruitment from '../sections/Recruitment';
import TwitterLink from '../components/TwitterLink';
import Contact from '../components/Contact';

const IndexPage = () => (
  <Layout>
    <Header />
    <Landing />
    <About />
    <Projects />
    <Recruitment />
    <Map />
    <Contact />
    <TwitterLink />
    <Footer />
  </Layout>
);

export default IndexPage;
